var banner = function () {
    var banners = Array.from(document.querySelectorAll('.bloque.banner'));
    if (banners.length === 0) {
        return;
    }
    var actualiza = function () {
        banners.forEach(function (banner) {
            var rect = banner.getBoundingClientRect();
            banner.style.setProperty('--distancia', "".concat(rect.top, "px"));
            document.documentElement.style.setProperty('--altura-banner', "".concat(rect.height, "px"));
        });
    };
    actualiza();
    window.addEventListener('resize', actualiza);
    window.addEventListener('scroll', actualiza);
};
export default banner;
